var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFileLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 14.5V15H19V14.5C19 13.6716 18.3284 13 17.5 13C16.6716 13 16 13.6716 16 14.5ZM14 15V14.5C14 12.567 15.567 11 17.5 11C19.433 11 21 12.567 21 14.5V15C21.5523 15 22 15.4477 22 16V21C22 21.5523 21.5523 22 21 22H14C13.4477 22 13 21.5523 13 21V16C13 15.4477 13.4477 15 14 15Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 20V16C11.5 15.1702 11.9043 14.4348 12.5267 13.98C12.7868 11.4629 14.9142 9.5 17.5 9.5C19.4791 9.5 21.1896 10.6499 22 12.3179V9C22 7.89543 21.1046 7 20 7H13.8284C13.298 7 12.7893 6.78929 12.4142 6.41421L10.5858 4.58579C10.2107 4.21071 9.70201 4 9.17157 4H4C2.89543 4 2 4.89543 2 6V18C2 19.1046 2.89543 20 4 20H11.5Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileLock);
export default __webpack_public_path__ + "static/media/file-lock.c44490fc0101fbf977c0ea574b5631b0.svg";
export { ForwardRef as ReactComponent };